import {
  MOBILE_PREPAID,
  ONLY_CONTRACT,
  CONTRACT_PREPAID,
  ONLY_PREPAID,
  allKindProduct,
  SERVICE_TIPO_DESVIO,
  ID_ACTIVACION,
  CONECTED,
  DISCONECTED,
  XBOX_GAME_PASS,
  SEGURO_MOVIL_PRODUCT_OFFERING_TYPE,
  MOVISTAR_CAR_PRODUCT_OFFERING_TYPE,
  MOVISTAR_CAR_POIDS,
  SEGURO_MOVIL_POIDS,
  FICCION_TOTAL_DISNEY_ANTIGUO_POID,
  FICCION_DISNEY_NETFLIX_ANTIGUO_POID,
  DISNEY_ESTANDAR_ANTIGUO_POID,
  EQUIPAMIENTO_PRODUCT_OFFERING_TYPE,
} from "@/constants/constants";
import { TELEVISION, OTROS, DISNEY_ACTIVATED } from "@/constants/tv";

import { htmlEncode } from "@/utils/htmlUtils";
import { getActiveConfigs } from "@/sagas/normalizers/get-active-configs";
import { getProductOfferingTextByType } from "@/utils/dataHandlers/CatalogueDataHandler";
import { TEXT_TYPES_CODES } from "@/constants/catalogue";
import { getProductByProductId, getRemainingQuotes, linkToRedirect } from "@/utils/dataHandlers/ProductDataHandler";
import toKebabCase from "@gcloud-npm/utils.common.to-kebap-case";
import { COLOR_DICTIONARY } from "@gcloud-npm/utils.enums.colors";
import { formatRenttoRentDate } from "@/utils/commonUtils";
import {
  DESVIO,
  BUZON,
  OCULTACION,
} from "@/constants/general-managment-constants";

export const TIPO_SERVICIO = {
  PERDIDAS: "perdidas",
  BUZON: BUZON,
  OCULTACION: OCULTACION,
  DESVIO: DESVIO,
};
export const NAME_SERVICIO = {
  perdidas_true: "Llamadas perdidas activado",
  perdidas_false: "Llamadas perdidas desactivado",
  buzon_true: "Buzón de voz activado",
  buzon_false: "Buzón de voz desactivado",
  ocultacion: "Ocultación de identidad activada",
  desvio: "Hay desvíos de llamadas activos",
};
export const OK = "OK";
export const KO = "KO";

export const getIdsOfItems = (hiredProduct, productType) => {
  const idsArray = [];
  let lastPhoneNumberOfCurrentBundle = null;
  // phone
  const productHasPhone =
    (productType >= 0 && productType < 3) || productType === 4;
  const productHasPhone1 = hiredProduct.phone !== null;
  if (productHasPhone && productHasPhone1) {
    const { linesPhone } = hiredProduct.phone;
    linesPhone.map((currentLines) => {
      const kindProduct = allKindProduct.phone;
      const res = {
        kindProduct,
        number: currentLines.number,
        productId: currentLines.productId,
        name: currentLines.description,
        poId: currentLines.poId,
      };
      lastPhoneNumberOfCurrentBundle = currentLines.number;
      idsArray.push(res);
      return null;
    });
  }
  // 1) mobiles
  const productHasMobile =
    productType === 0 || productType === 3 || productType === 5;
  const productHasMobile1 = hiredProduct.mobile !== null;
  if (productHasMobile && productHasMobile1) {
    const { linesMobile } = hiredProduct.mobile;
    linesMobile.map((currentLines) => {
      const kindProduct = allKindProduct.mobile;
      const res = {
        kindProduct,
        number: currentLines.number,
        productId: currentLines.productId,
        name: currentLines.name,
        poId: currentLines.poId,
      };
      idsArray.push(res);
      return null;
    });
  }
  // 2) internet
  const productHasInternet =
    productType === 0 || productType === 1 || productType === 2;
  const productHasInternet1 = hiredProduct.internet !== null;
  if (productHasInternet && productHasInternet1) {
    const kindProduct = allKindProduct.internet;
    const res = {
      kindProduct,
      productId: hiredProduct.internet.productId,
      name: hiredProduct.internet.description,
      poId: hiredProduct.internet.poId,
      resources: hiredProduct?.internet?.resources,
    };
    if (lastPhoneNumberOfCurrentBundle) {
      res.number = lastPhoneNumberOfCurrentBundle;
    }
    idsArray.push(res);
  }
  // tv
  const productHasTv = productType === 0 || productType === 1;
  const productHasTv1 = hiredProduct.tv !== null;
  if (productHasTv && productHasTv1) {
    const kindProduct = allKindProduct.tv;
    const res = {
      kindProduct,
      productId: hiredProduct.tv.productId,
      name: hiredProduct.tv.description,
      poId: hiredProduct.tv.poId,
      resources: hiredProduct?.tv?.resources,
    };
    if (lastPhoneNumberOfCurrentBundle) {
      res.number = lastPhoneNumberOfCurrentBundle;
    }
    idsArray.push(res);
  }
  return idsArray;
};

export const getAllDataItems = (hiredProduct) => {
  const idsArray = getIdsOfItems(hiredProduct, hiredProduct.productType);
  return idsArray;
};

function decodeHtmlEntities(input) {
  if (input) {
    return input.replace(/&([^;]+);/g, function (entity, entityCode) {
      var match;

      // Handle named entities
      if (entityCode in entities) {
        return entities[entityCode];
      } else if ((match = entityCode.match(/^#x([\da-fA-F]+)$/))) {
        // Handle hexadecimal entities
        return String.fromCharCode(parseInt(match[1], 16));
      } else if ((match = entityCode.match(/^#(\d+)$/))) {
        // Handle decimal entities
        return String.fromCharCode(~~match[1]);
      } else {
        return entity;
      }
    });
  }
}

var entities = {
  nbsp: " ",
  amp: "&",
  quot: '"',
  lt: "<",
  gt: ">",
  aacute: "á",
  eacute: "é",
  iacute: "í",
  oacute: "ó",
  uacute: "ú",
  ntilde: "ñ",
  Aacute: "Á",
  Eacute: "É",
  Iacute: "Í",
  Oacute: "Ó",
  Uacute: "Ú",
  Ntilde: "Ñ",
};

export const normalizeGetMyProducts = (myProducts) => {
  try {
    const hiredProducts = [];

    const hasIntegralDigitalProtection = myProducts.productosContratados.some(
      (product) => product.poId === "3773"
    );

    myProducts.productosContratados.forEach((elem) => {
      elem.internet &&
        hiredProducts.push({
          name: decodeHtmlEntities(elem.name),
          subseccion: elem.subseccion,
          productType: elem.productType,
          productOfferingTypes: elem.productOfferingTypes,
          poId: elem.poId,
          productId: elem.productId,
          internetProductId: elem.internet.productId,
          phone: elem.phone.linesPhone[0].number,
          phoneProductId: elem.phone.linesPhone[0].productId,
          digitalProtection: {
            hasDigitalProtection:
              elem.internet.productosContratadosDedependientes.some(
                (product) => product.poId === "411"
              ),
            digitalProtectionProductId:
              elem.internet.productosContratadosDedependientes.find(
                (product) => product.poId === "411"
              )?.productId,
          },
          internetType: elem.internet.internetType,
        });

      if (hasIntegralDigitalProtection && elem.internet) {
        const esentialDigitalProtection =
          elem.internet.productosContratadosDedependientes.find(
            (product) => product.poId === "411"
          );

        esentialDigitalProtection &&
          hiredProducts.push(esentialDigitalProtection);
      }

      elem.mobile?.linesMobile?.length > 0 &&
        elem.mobile.linesMobile.forEach((line) => {
          hiredProducts.push({
            name: decodeHtmlEntities(line.name),
            subseccion: line.subseccion,
            productType: elem.internet ? 3 : elem.productType,
            productOfferingTypes: elem.internet
              ? [{ id: "4", name: "TARIFA MOVIL" }]
              : elem.productOfferingTypes,
            productOfferingTypesInBundle:
              line.productosContratadosDedependientes[0]
                ?.productOfferingTypesInBundle,
            productosContratadosDedependientes:
              line.productosContratadosDedependientes,
            poId: line.poId,
            number: line.number,
            productId: line.productId,
            parentProductId: elem.productId,
            resources: line.resources,
          });

          Array.isArray(line.productosContratadosDedependientes) &&
            line.productosContratadosDedependientes.length > 0 &&
            line.productosContratadosDedependientes.forEach((producto) => {
              if (
                MOVISTAR_CAR_POIDS.includes(producto.poId) ||
                SEGURO_MOVIL_POIDS.includes(producto.poId) ||
                producto.productOfferingTypes.some(
                  ({ id }) => id === XBOX_GAME_PASS
                )
              ) {
                hiredProducts.push({
                  name: producto.productOfferingTypes.some(
                    ({ id }) => id === XBOX_GAME_PASS
                  )
                    ? line.number
                    : decodeHtmlEntities(producto.name),
                  subseccion: producto.subseccion,
                  productType: producto.productType,
                  productOfferingTypes: fixCatalogingByName(producto),
                  productOfferingTypesInBundle:
                    elem.productOfferingTypesInBundle,
                  poId: producto.poId,
                  productId: producto.productId,
                  parentProductId: line.productId,
                  dependenciasTecnicas: producto.dependenciasTecnicas || [],
                  startDate: producto.startDate || null,
                  endDate: producto.endDate || null,
                });
              }
            });
        });

      elem?.tv &&
        hiredProducts.push({
          name: decodeHtmlEntities(elem.tv.description),
          subseccion: elem.subseccion,
          productType: 9,
          productOfferingTypes: [{ id: "7", name: "TELEVISION" }],
          poId: elem.tv.poId,
          productId: elem.tv.productId,
          administrativeNumber: elem.tv.administrativeNumber,
          parentProductId: elem.productId,
          productosContratadosDedependientesProductId:
            elem.tv.productosContratadosDedependientes
              .filter((producto) => producto.poId !== DISNEY_ACTIVATED)
              .map((producto) => producto.productId),
          hasOldDisneyPark: elem.tv.productosContratadosDedependientes.some(
            (producto) =>
              [
                FICCION_DISNEY_NETFLIX_ANTIGUO_POID,
                FICCION_TOTAL_DISNEY_ANTIGUO_POID,
                DISNEY_ESTANDAR_ANTIGUO_POID,
              ].includes(producto.poId)
          ),
        });

      elem?.tv?.productosContratadosDedependientes?.length > 0 &&
        elem.tv.productosContratadosDedependientes.forEach((producto) => {
          if (producto.poId !== DISNEY_ACTIVATED) {
            hiredProducts.push({
              name: decodeHtmlEntities(producto.name),
              subseccion: elem.subseccion,
              productType: producto.productType,
              productOfferingTypes: producto.productOfferingTypes.some(
                ({ id }) => id === OTROS
              )
                ? producto.productOfferingTypes.filter(
                    (elem) => elem.id !== TELEVISION
                  )
                : producto.productOfferingTypes,
              bundleId: producto.bundleId || null,
              poId: producto.poId,
              productId: producto.productId,
              parentProductId: elem.tv.productId,
              characteristics: producto?.characteristics || [],
            });
          }
        });

      !elem.internet &&
        !elem.mobile &&
        !elem.tv &&
        elem.phone &&
        elem.phone.linesPhone.forEach((line) => {
          hiredProducts.push({
            name: decodeHtmlEntities(elem.name),
            subseccion: elem.subseccion,
            productType: elem.productType,
            productOfferingTypes: elem.productOfferingTypes,
            poId: elem.poId,
            productId: elem.productId,
          });
        });

      !elem.internet &&
        !elem.mobile &&
        !elem.tv &&
        !elem.phone &&
        hiredProducts.push({
          name:
            decodeHtmlEntities(elem.name.split(":")[1]) ||
            decodeHtmlEntities(elem.name),
          subseccion: elem.subseccion,
          productType: elem.productType,
          productOfferingTypes: fixCatalogingByName(elem),
          poId: elem.poId,
          productId: elem.productId,
        });
    });

    return hiredProducts;
  } catch (error) {
    console.log("ERROR in getMyProducts Normalizer", error);
  }
};

export const fixCatalogingByName = (product) => {
  if (MOVISTAR_CAR_POIDS.includes(product.poId)) {
    return [{ id: MOVISTAR_CAR_PRODUCT_OFFERING_TYPE, name: "MOVISTAR_CAR" }];
  }

  if (SEGURO_MOVIL_POIDS.includes(product.poId)) {
    return [{ id: SEGURO_MOVIL_PRODUCT_OFFERING_TYPE, name: "SEGURO_MOVIL" }];
  }

  if (product?.productOfferingTypes.some(({ id }) => id === XBOX_GAME_PASS)) {
    return [{ id: XBOX_GAME_PASS, name: "XBOX_GAME_PASS" }];
  }
  return product.productOfferingTypes;
};

export const normalizeClientProduct = (myProducts) => {
  const myProductsNew = [];
  if (myProducts?.productosContratados) {
    myProducts.productosContratados.forEach((product, index) => {
      if (
        product.productType === 0 ||
        product.productType === 1 ||
        product.productType === 2 ||
        product.productType === 3 ||
        product.productType === 4 ||
        product.productType === 5 ||
        product.productType === 9
      ) {
        const newProductObj = product;
        if (newProductObj.name) {
          newProductObj.name = htmlEncode(newProductObj.name);
        }
        if (newProductObj.description) {
          newProductObj.description = htmlEncode(newProductObj.description);
        }

        let newLinesMobile = null;
        if (product.mobile && product.mobile.linesMobile) {
          newLinesMobile = product.mobile.linesMobile.map((itemMobile) => {
            const newItemLineMobile = itemMobile;
            newItemLineMobile.main = false;
            return newItemLineMobile;
          });
        }
        if (newLinesMobile) {
          newProductObj.mobile.linesMobile = newLinesMobile;
        }
        if (
          product.productStatuses &&
          Array.isArray(product.productStatuses) &&
          product.productStatuses.length > 0
        ) {
          const idActivate = product.productStatuses[0].id;
          newProductObj.productStatuses =
            idActivate === ID_ACTIVACION ? CONECTED : DISCONECTED;
          newProductObj.productIdStatuses = idActivate;
          newProductObj.productStatusesColor =
            idActivate === ID_ACTIVACION
              ? COLOR_DICTIONARY.GREEN
              : COLOR_DICTIONARY.GREY4;
        }
        const ids2Add = getAllDataItems(product);

        const newProduct = {
          ...newProductObj,
          childProductId: ids2Add,
        };
        myProductsNew.push(newProduct);
      }
    });
  }

  return myProductsNew;
};

export const normalizeBundleProduct = (myProducts) => {
  let bundle = 99;
  myProducts.forEach((product, index) => {
    if (product.productType < bundle) {
      bundle = product.productType;
    }
  });

  return bundle;
};

export const getBundleFromMobileProductId = (hiredProducts, productId) => {
  let bundleRes = null;
  hiredProducts.forEach((bundle) => {
    const { mobile } = bundle;
    if (mobile && bundle.mobile && bundle.mobile.linesMobile && !bundleRes) {
      const { linesMobile } = mobile;
      linesMobile.forEach((itemLine) => {
        // console.log('bundle', itemLine.productId, productId, !bundleRes)
        if (itemLine.productId === productId && !bundleRes) {
          bundleRes = bundle;
        }
      });
    }
  });
  return bundleRes;
};
export const getMobileFromMobileProductId = (hiredProducts, productId) => {
  const bundle = getBundleFromMobileProductId(hiredProducts, productId);
  if (bundle && bundle.mobile && bundle.mobile.linesMobile) {
    return bundle.mobile.linesMobile.find((x) => x.productId === productId);
  }
  return null;
};

export const getMisProductosRenttorentResponseNormalizer = (
  response,
  typeR2R
) => {
  let misProductosR2RNormalized = null;
  if (
    response &&
    Array.isArray(response.productosRentToRent) &&
    response.productosRentToRent.length > 0
  ) {
    misProductosR2RNormalized = response.productosRentToRent;
    misProductosR2RNormalized.forEach((item) => {
      item.typeR2R = typeR2R;
      if (item.fechaVencimientoTemporal) {
        item.fechaVencimientoTemporal = formatRenttoRentDate({
          dateString: item.fechaVencimientoTemporal,
        });
      }
      if (item.fechaVencimiento) {
        item.fechaVencimiento = formatRenttoRentDate({
          dateString: item.fechaVencimiento,
        });
      }
    });
  }
  return misProductosR2RNormalized;
};

export const mobileRestrictionStatusNormalizer = (
  phone,
  mobileRestrictionData
) => {
  return {
    [phone]: mobileRestrictionData,
  };
};

export const mobileRestrictionStatusNormalizerActiveDeactive = (
  phone,
  mobileRestrictionData
) => {
  const activeRestrictions = {};
  const deActiveRestrictions = {};
  let fullRestrictions = [];
  if (mobileRestrictionData && mobileRestrictionData.groups) {
    const restrictions = mobileRestrictionData.groups.filter(
      (x) => x.restricciones !== null
    );
    const groupsRestrictions = mobileRestrictionData.groups.filter(
      (x) => x.groups !== null
    );
    if (restrictions) {
      fullRestrictions = [...fullRestrictions, ...restrictions];
    }
    if (groupsRestrictions) {
      const innerRestrictions = groupsRestrictions.map((x) =>
        x.groups.filter((y) => y.restricciones !== null)
      );
      const innerGroupsRestrictions = groupsRestrictions.map((x) =>
        x.groups.filter((y) => y.groups !== null)
      );
      if (
        innerRestrictions &&
        Array.isArray(innerRestrictions) &&
        innerRestrictions.length > 0
      ) {
        fullRestrictions = [...fullRestrictions, ...innerRestrictions[0]];
      }
      if (
        innerGroupsRestrictions &&
        Array.isArray(innerGroupsRestrictions) &&
        innerGroupsRestrictions.length > 0
      ) {
        const reInnerRestrictions = innerGroupsRestrictions.map((z) =>
          z.map((x) => x.groups.filter((y) => y.restricciones !== null))
        );
        if (reInnerRestrictions) {
          fullRestrictions = [
            ...fullRestrictions,
            ...reInnerRestrictions[0][0],
          ];
        }
      }
    }
    fullRestrictions = fullRestrictions
      .map((x) => x.restricciones)
      .flatMap((e) => [...e]);
    const fullRestrictionsTrue = fullRestrictions.filter(
      (x) => x.estado === true
    );
    fullRestrictionsTrue.map(
      (x) =>
        (activeRestrictions[x.idRestriccion] = {
          idRestriccion: x.idRestriccion,
          name: normalizeNameRestriction(x.name),
          estado: x.estado,
          id: x.id,
          inhabilitado: x.inhabilitado,
        })
    );
    const fullRestrictionsFalse = fullRestrictions.filter(
      (x) => x.estado === false
    );
    fullRestrictionsFalse.map(
      (x) =>
        (deActiveRestrictions[x.idRestriccion] = {
          idRestriccion: x.idRestriccion,
          name: normalizeNameRestriction(x.name),
          estado: x.estado,
          id: x.id,
          inhabilitado: x.inhabilitado,
        })
    );
  }
  // return activeRestrictions;
  return {
    [phone]: { activeRestrictions, deActiveRestrictions },
  };
};

const normalizeNameRestriction = (name) => {
  return name;
};

export function* mobileDetailConfigStatusNormalizer(mobileConfigDataReq) {
  const { data: mobileConfigData } = mobileConfigDataReq;
  let fullConfigsBuzon = [];
  let fullConfigsDesvio = [];
  let fullConfigsOcultacion = [];
  let fullConfigsPerdidas = [];
  let parallelConfigList = [];
  let activeConfigs = {};

  fullConfigsBuzon = mobileConfigData.lineas.filter(
    (x) => x.tipo_servicio === TIPO_SERVICIO.BUZON
  );
  fullConfigsDesvio = mobileConfigData.lineas.filter(
    (x) => x.tipo_servicio === TIPO_SERVICIO.DESVIO
  );
  fullConfigsOcultacion = mobileConfigData.lineas.filter(
    (x) => x.tipo_servicio === TIPO_SERVICIO.OCULTACION
  );
  fullConfigsPerdidas = mobileConfigData.lineas.filter(
    (x) => x.tipo_servicio === TIPO_SERVICIO.PERDIDAS
  );

  if (
    fullConfigsBuzon &&
    Array.isArray(fullConfigsBuzon) &&
    fullConfigsBuzon.length > 0
  ) {
    activeConfigs = {
      ...activeConfigs,
      ...getActiveConfigs({
        configs: fullConfigsBuzon,
        tipoServicio: TIPO_SERVICIO.BUZON,
      }),
    };
  }
  if (
    fullConfigsDesvio &&
    Array.isArray(fullConfigsDesvio) &&
    fullConfigsDesvio.length > 0
  ) {
    activeConfigs = {
      ...activeConfigs,
      ...getActiveConfigs({
        configs: fullConfigsDesvio,
        tipoServicio: TIPO_SERVICIO.DESVIO,
      }),
    };
  }
  if (
    fullConfigsOcultacion &&
    Array.isArray(fullConfigsOcultacion) &&
    fullConfigsOcultacion.length > 0
  ) {
    activeConfigs = {
      ...activeConfigs,
      ...getActiveConfigs({
        configs: fullConfigsOcultacion,
        tipoServicio: TIPO_SERVICIO.OCULTACION,
      }),
    };
  }
  if (
    fullConfigsPerdidas &&
    Array.isArray(fullConfigsPerdidas) &&
    fullConfigsPerdidas.length > 0
  ) {
    activeConfigs = {
      ...activeConfigs,
      ...getActiveConfigs({
        configs: fullConfigsPerdidas,
        tipoServicio: TIPO_SERVICIO.PERDIDAS,
      }),
    };
  }
  return activeConfigs;
}

export const mobileDetailRestrictionStatusNormalizer = (
  phone,
  mobileRestrictionData
) => {
  const activeRestrictions = {};
  let fullRestrictions = [];
  if (mobileRestrictionData && mobileRestrictionData.groups) {
    const restrictions = mobileRestrictionData.groups.filter(
      (x) => x.restricciones !== null
    );
    const groupsRestrictions = mobileRestrictionData.groups.filter(
      (x) => x.groups !== null
    );
    if (restrictions) {
      fullRestrictions = [...fullRestrictions, ...restrictions];
    }
    if (groupsRestrictions) {
      const innerRestrictions = groupsRestrictions.map((x) =>
        x.groups.filter((y) => y.restricciones !== null)
      );
      const innerGroupsRestrictions = groupsRestrictions.map((x) =>
        x.groups.filter((y) => y.groups !== null)
      );
      if (innerRestrictions && Array.isArray(innerRestrictions) && innerRestrictions.length > 0 && innerRestrictions[0]) {
        fullRestrictions = [...fullRestrictions, ...innerRestrictions[0]];
      }
      if (innerGroupsRestrictions && Array.isArray(innerGroupsRestrictions) && innerGroupsRestrictions.length > 0) {
        const reInnerRestrictions = innerGroupsRestrictions.map((z) =>
          z.map((x) => x.groups.filter((y) => y.restricciones !== null))
        );
        if (reInnerRestrictions) {
          fullRestrictions = [
            ...fullRestrictions,
            ...reInnerRestrictions[0][0],
          ];
        }
      }
    }
    fullRestrictions = fullRestrictions
      .map((x) => x.restricciones)
      .flatMap((e) => [...e]);
    fullRestrictions = fullRestrictions.filter((x) => x.estado === true);
    fullRestrictions.map(
      (x) =>
        (activeRestrictions[x.idRestriccion] = {
          idRestriccion: x.idRestriccion,
          name: normalizeNameRestriction(x.name),
          estado: x.estado,
          id: x.id,
          inhabilitado: x.inhabilitado,
        })
    );
  }
  return activeRestrictions;
};

export const getKindClient = (myProducts) => {
  let hasPrepaid = false;

  let hasContract = false;

  let kindProduct = ONLY_CONTRACT;

  myProducts.forEach((product) => {
    if (product.productType === MOBILE_PREPAID) {
      hasPrepaid = true;
    } else {
      hasContract = true;
    }
  });

  if (hasPrepaid && hasContract) {
    kindProduct = CONTRACT_PREPAID;
  } else if (hasPrepaid) {
    kindProduct = ONLY_PREPAID;
  }

  return kindProduct;
};

export const getSmartWiFiDataResponseNormalizer = (
  phone,
  smartWiFiStatus,
  connectedDevices
) => {
  const { contratado } = { ...smartWiFiStatus };
  const { dispositivos } = { ...connectedDevices };
  return {
    [phone]: {
      hired: contratado || false,
      numberOfDevicesConnected: dispositivos || 0,
    },
  };
};
export const mobileConfigurationStatusNormalizer = (
  phone,
  mobileConfigData
) => {
  const { lineas: servicesInfo } = { ...mobileConfigData };
  if (servicesInfo && Array.isArray(servicesInfo)) {
    const servicesInfoFiltered = servicesInfo.filter(
      (service) => service.tipo_desvio !== SERVICE_TIPO_DESVIO.N
    );
    const servicesGrouped = servicesInfoFiltered.reduce((r, a) => {
      r[a.tipo_servicio] = [...(r[a.tipo_servicio] || []), a];
      return r;
    }, {});
    return {
      [phone]: servicesGrouped,
    };
  }
  return {
    [phone]: null,
  };
};

export const getPukCodeDataResponseNormalizer = (response, productId) => {
  let pukCodeDataNormalized = null;
  if (response && response.datos) {
    pukCodeDataNormalized = response.datos;
    pukCodeDataNormalized.productId = productId;
  }
  return pukCodeDataNormalized;
};

export const getImageR2R = ({ offers }) => {
  let image = null;
  if (offers) {
    if (
      !image &&
      offers?.libre[0]?.imgs &&
      Array.isArray(offers?.libre[0]?.imgs) &&
      offers?.libre[0]?.imgs.length > 0
    ) {
      image = offers.libre[0].imgs[0];
    } else if (
      !image &&
      offers?.r2r[0]?.imgs &&
      Array.isArray(offers?.r2r[0]?.imgs) &&
      offers?.r2r[0]?.imgs.length > 0
    ) {
      image = offers.r2r[0].imgs[0];
    } else if (
      !image &&
      offers?.r2rAdditional[0]?.imgs &&
      Array.isArray(offers?.r2rAdditional[0]?.imgs) &&
      offers?.r2rAdditional[0]?.imgs.length > 0
    ) {
      image = offers.r2rAdditional[0].imgs[0];
    }
  }
  return image;
};

export const getNameR2R = ({ offers }) => {
  let name = null;
  if (offers) {
    if (
      !name &&
      offers?.libre[0]?.name
    ) {
      image = offers.libre[0].name;
    } else if (
      !name &&
      offers?.r2r[0]?.name
    ) {
      name = offers.r2r[0].name;
    } else if (
      !name &&
      offers?.r2rAdditional[0]?.name
    ) {
      name = offers.r2rAdditional[0].name;
    }
  }
  return name;
};

export const getCompleteDonutListArrayActivateLine = (response) => {
  let result = [];
  if (
    response &&
    response.listaOpcionesActivacionLinea &&
    Array.isArray(response.listaOpcionesActivacionLinea) &&
    response.listaOpcionesActivacionLinea.length > 0
  ) {
    response.listaOpcionesActivacionLinea.map((line, index) => {
      let productTemp = {
        id: line.id,
        productOfferingId: line.productOfferingId,
        name: line.name,
        subtype: line.subtype,
        productOfferingCategoriesId: line.productOfferingTypes[0].id,
        productOfferingCategoriesName: line.productOfferingTypes[0].name,
        productOffering: null,
        PODestino: null,
      };
      if (
        line.choices &&
        Array.isArray(line.choices) &&
        line.choices.length > 0
      )
        line.choices.map((choice, index) => {
          let quantity = choice.maxLines;
          if (quantity === null) {
            quantity = 1;
          }
          for (let i = 1; i <= quantity; i += 1) {
            const { id, subtype, productOfferingCategoriesId } = productTemp;
            const alias = getProductOfferingTextByType(
              choice.productOffering,
              TEXT_TYPES_CODES.ORDINARY
            );
            const PODestino = choice?.productOffering?.id;
            productTemp.productOffering = choice.productOffering;
            productTemp.PODestino = PODestino;
            productTemp.description = getProductOfferingTextByType(
              choice.productOffering,
              TEXT_TYPES_CODES.BRIEF
            );
            productTemp.link = linkToRedirect(
              id,
              choice.productOffering.id,
              subtype,
              productOfferingCategoriesId,
              toKebabCase(alias)
            );
            result.push({ ...productTemp });
          }
        });
    });
    return result;
  }
  return null;
};

export const normalizeQuoteR2R = (quote) => {
  if (quote) {
    const parts = quote.split("€");

    if (parts.length === 2) {
      const price = parts[0].trim();
      const unity = `€${parts[1].trim()}`
      return {
        price: price && price.replace(",00", ""),
        unity: unity,
      };
    }
  }
};

export const findImageEquipment = (id, cards) => {
  if (cards && Array.isArray(cards) && cards.length > 0 && id) {
    const card = cards.find((item) => item.idCard === id);
    if (card) {
      const { imgCard, href, name } = card;
      return { imgCard, href, name }
    }
  }
}

export const getCatalogueNameEquipment = (catalogTexts) => {
  let catalogName = null;
  if (Array.isArray(catalogTexts) && catalogTexts.length > 0) {
    catalogName = catalogTexts.find((texts) => texts?.textTypeId === TEXT_TYPES_CODES.ORDINARY);
    catalogName = catalogName?.text;
  }
  return catalogName;
}

export const normalizeUpgradeEquipment = (equip, cards) => {
  if (equip && Array.isArray(equip) && equip.length > 0) {
    const data = equip.map((item) => {
      const { id, actionName, resourceSpecs, resourceSpecPAIN } = item;
      const products = [];
      let cardDetail = null;
      let showEquipment = true;
      if (resourceSpecPAIN) {
        const { id, name, catalogTexts } = resourceSpecPAIN;
        const catalogName = getCatalogueNameEquipment(catalogTexts);
        const image = findImageEquipment(id, cards);
        const obj = { id, name: (catalogName || name) ,contracted: true, imgCard: image?.imgCard, href: image?.href }
        cardDetail = obj
        products.push(obj);  
      }
      if (resourceSpecs && Array.isArray(resourceSpecs) && resourceSpecs.length > 0) {
        resourceSpecs.forEach((product) => {
          const { id, name, price, catalogTexts } = product;
          const catalogName = getCatalogueNameEquipment(catalogTexts);
          const image = findImageEquipment(id, cards);
          const obj = { id, name: (catalogName || name), price: `${price?.amount} €`, imgCard: image?.imgCard, href: image?.href};
          products.push(obj);  
        })
      } else {
        showEquipment = false;
      }

      return { id, title: actionName, products, cardDetail, showEquipment }
    })
    return data;
  } else if (equip && Array.isArray(equip) && equip.length === 0) {
    return equip
  }
}

export const getDefaultCardEquipment = ({ hiredProducts, productId, cards, idEquip }) => {
  if (hiredProducts && Array.isArray(hiredProducts) && hiredProducts.length > 0 && productId) {
    const product = getProductByProductId(hiredProducts, productId);
    let resources = null;
    resources = (idEquip === "1") ? product?.internet?.resources?.[0] : product?.tv?.resources?.[0]; 
    if (resources) {
      const { resourceSpecId, resourceSpecName } = resources;
      const image = findImageEquipment(resourceSpecId, cards);

      return { id: resourceSpecId, cardDetail: { imgCard: image?.imgCard , name: (image?.name || resourceSpecName) } }
    }
  }
}

export const hasResourcesInternetInfo = ({ hiredProducts, productId }) => {
  if (hiredProducts && Array.isArray(hiredProducts) && hiredProducts.length > 0 && productId) {
    const product = getProductByProductId(hiredProducts, productId);
    const resources = product?.internet?.resources?.[0];

    return resources ? true : false;
  }
}
export const getPriceAndExpirationDateFttrProducts = (productosRentToRent = []) => {
  if (!Array.isArray(productosRentToRent) || productosRentToRent.length === 0) {
    return [];
  }

  return productosRentToRent.map((product) => {
    const { idPO, fechaInicio, fechaVencimiento, cuotaActualConPrecio } = product;

    const quote = normalizeQuoteR2R(cuotaActualConPrecio);
    const initDate = formatRenttoRentDate({ dateString: fechaInicio });
    const endDate = formatRenttoRentDate({ dateString: fechaVencimiento });
    const remainingQuotes = getRemainingQuotes({ endDate });

    return { 
      idPO,
      quote,
      initDate,
      remainingQuotes,
      endDate,
      labelHiringDate: `Fecha de contratación: <span class="text-gp--font-bold">${initDate}</span>`,
      labelRemainingQuotes: `Te quedan ${remainingQuotes} cuotas hasta el ${endDate}`,
    };
  });
};


